/*
  grillzen-product.js — галерея та sticky-бар секції товару (sections/grillzen-product.liquid).
  Без бібліотек: галерея на scroll-snap, індекс слайда рахуємо зі scrollLeft.
*/
(function () {
  'use strict';

  // ---------- галерея ----------
  document.querySelectorAll('[data-gzp-gallery]').forEach(function (g) {
    var track = g.querySelector('[data-gzp-track]');
    if (!track) return;
    var slides = [].slice.call(track.children);
    var thumbsWrap = g.querySelector('[data-gzp-thumbs]');
    var thumbs = [].slice.call(g.querySelectorAll('[data-gzp-thumb]'));
    var dots = [].slice.call(g.querySelectorAll('.gzp-gal__dot'));
    var counter = g.querySelector('[data-gzp-current]');
    var prev = g.querySelector('[data-gzp-prev]');
    var next = g.querySelector('[data-gzp-next]');
    var n = slides.length;
    var idx = 0;

    function width() { return track.clientWidth || 1; }

    function go(i, instant) {
      i = Math.max(0, Math.min(n - 1, i));
      track.scrollTo({ left: i * width(), behavior: instant ? 'auto' : 'smooth' });
    }

    function setActive(i) {
      if (i === idx) return;
      idx = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      if (counter) counter.textContent = i + 1;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === n - 1;
      // мініатюру підкручуємо всередині її стрічки, не сторінку (scrollIntoView зсував би екран)
      var t = thumbs[i];
      if (t && thumbsWrap) {
        thumbsWrap.scrollTo({ left: t.offsetLeft - thumbsWrap.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
      }
      // відео на неактивних слайдах ставимо на паузу
      slides.forEach(function (s, k) {
        if (k !== i) s.querySelectorAll('video').forEach(function (v) { v.pause(); });
      });
    }

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        setActive(Math.round(track.scrollLeft / width()));
      });
    }, { passive: true });

    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    if (prev) { prev.addEventListener('click', function () { go(idx - 1); }); prev.disabled = true; }
    if (next) { next.addEventListener('click', function () { go(idx + 1); }); next.disabled = n <= 1; }
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
    });
    window.addEventListener('resize', function () { go(idx, true); });
  });

  // ---------- вибір варіанта (товари без бандла) ----------
  var sel = document.querySelector('[data-gzp-variant]');
  if (sel) {
    sel.addEventListener('change', function () {
      var id = sel.value;
      var idInput = document.querySelector('[data-gzp-form] input[name="id"]');
      if (idInput) idInput.value = id;
      document.querySelectorAll('[data-gzp-price-for]').forEach(function (p) {
        p.hidden = p.getAttribute('data-gzp-price-for') !== id;
      });
      var opt = sel.options[sel.selectedIndex];
      var btn = document.querySelector('[data-gzp-atc]');
      if (btn && opt) {
        var avail = opt.getAttribute('data-available') === 'true';
        btn.disabled = !avail;
        btn.textContent = avail ? 'ADD TO CART' : 'SOLD OUT';
      }
    });
  }

  // ---------- sticky-бар ----------
  var sticky = document.querySelector('[data-gzp-sticky]');
  if (sticky) {
    // орієнтир — кнопка бандла; якщо бандла нема — кнопка звичайної форми
    var mainBtn = document.querySelector('[data-gz-atc]') || document.querySelector('[data-gzp-atc]');
    var closed = false;

    function show(on) {
      sticky.classList.toggle('is-visible', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.body.classList.toggle('gzp-sticky-open', on);
    }

    if (mainBtn) {
      // показуємо, лише коли кнопка вже прокручена вище екрана.
      // IntersectionObserver + запасний обробник scroll (не всі вбудовані браузери
      // надійно віддають IO-колбеки при програмному скролі)
      function update() {
        var r = mainBtn.getBoundingClientRect();
        show(!closed && r.bottom < 0);
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(update, { threshold: 0 }).observe(mainBtn);
      }
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; update(); });
      }, { passive: true });
    }

    var stickyBtn = sticky.querySelector('[data-gzp-sticky-atc]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (mainBtn) {
          mainBtn.click();                              // той самий шлях, що й головна кнопка (бандл + подарунки)
        } else {
          var f = document.querySelector('[data-gzp-form]');
          if (f) f.requestSubmit ? f.requestSubmit() : f.submit();
        }
      });
    }
    var closeBtn = sticky.querySelector('[data-gzp-sticky-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { closed = true; show(false); });
  }
})();
